import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, XCircle } from 'lucide-react';
import { BACKEND_URL } from '../config';
import { useAuth } from '../context/AuthContext';

export default function MagicLoginPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('Invalid link.');
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(`${BACKEND_URL}/api/auth/magic-login`, { token });
        if (data.success) {
          setSession(data.data.token, data.data.user);
          const onboarded = data.data.user?.preferences?.onboarding_completed;
          navigate(onboarded ? '/dashboard' : '/onboarding', { replace: true });
        } else {
          setError(data.message || 'This link is no longer valid.');
        }
      } catch (e) {
        setError(
          e.response?.data?.detail ||
            'This login link has expired. Please use the "Forgot password" option on the login page.'
        );
      }
    })();
  }, [params, navigate, setSession]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div
        data-testid="magic-login-container"
        className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 max-w-md w-full text-center"
      >
        {error ? (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <XCircle className="h-9 w-9 text-red-500" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Login link issue</h1>
            <p className="text-sm text-slate-500 mb-6">{error}</p>
            <button
              data-testid="magic-login-go-login-btn"
              onClick={() => navigate('/auth')}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2.5 rounded-xl"
            >
              Go to Login
            </button>
          </>
        ) : (
          <>
            <Loader2 className="h-10 w-10 text-blue-500 animate-spin mx-auto mb-4" />
            <h1 className="text-lg font-bold text-slate-900">Signing you in…</h1>
            <p className="text-sm text-slate-500 mt-2">
              Please wait, do not close this window.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
